import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ClipboardCheck, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { apiError, fmtD, fmtDT } from "@/lib/platform";
import { scoreTone } from "@/lib/vendors";
import { Panel } from "@/components/rights/RightsBadges";
import { ReviewBadge } from "@/components/vendors/VendorBadges";

export const AssessmentsPanel = ({ v, canEdit }) => {
  const nav = useNavigate();
  const start = async () => {
    try {
      const { data } = await api.post(`/vendors/${v.id}/assessments`, { carry_forward: true });
      toast.success(`${data.reference_number} started`);
      nav(`/vendors/${v.id}/assessments/${data.id}`);
    } catch (e) { toast.error(apiError(e, "Could not start assessment")); }
  };
  return (
    <Panel eyebrow="10-domain questionnaire" title="Vendor assessments" testId="assessments-panel"
           actions={canEdit && !v.active_review && (
             <Button size="sm" onClick={start} className="bg-[#003366] hover:bg-[#003366]/90" data-testid="assessment-start-button">
               <Plus className="w-3.5 h-3.5 mr-1" /> Start assessment</Button>
           )}>
      {v.reviews.length === 0 ? (
        <div className="text-xs text-slate-500 py-6 text-center border border-dashed border-slate-200 rounded-lg" data-testid="assessments-empty">
          No assessments yet. Initial assessment due {fmtD(v.next_assessment_due)}.
        </div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {v.reviews.map((r) => (
            <li key={r.id}>
              <button onClick={() => nav(`/vendors/${v.id}/assessments/${r.id}`)} data-testid={`assessment-row-${r.id}`}
                      className="w-full flex items-center gap-4 py-3 text-left hover:bg-slate-50/80 rounded-lg px-2 transition-colors">
                <ClipboardCheck className="w-4 h-4 text-slate-400" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-[#003366]"><span className="font-mono text-xs text-accent-sm">{r.reference_number}</span> · {r.cycle} assessment</div>
                  <div className="text-[11px] text-slate-500">Started {fmtDT(r.started_at)} by {r.started_by}{r.approved_at && ` · approved ${fmtD(r.approved_at)}`}</div>
                </div>
                <span className={`text-lg font-mono font-bold ${scoreTone(r.overall_score)}`}>{r.overall_score == null ? "—" : `${r.overall_score}%`}</span>
                <ReviewBadge status={r.status} label={r.status_label} testId={`assessment-status-${r.id}`} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};
